<cc-side-bar class="side-bar-max-size-plus" [(sidebarToggled)]="sidebarToggledChange"
             [menuItemsTop]="menuItemsTop" [menuItemsBottom]="menuItemsBottom">
  <ng-content bottom select="[bottom]"></ng-content>
  <ng-content body select="[body]"></ng-content>
</cc-side-bar>

